<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="도면명"
            name="diagramTitle"
            v-model="searchParam.diagramTitle">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-process
            label="관련공정"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-process>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          :title="pidInfo.title +  ' 목록'"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="psiPowerEquipmentId"
          :changeData="changeData"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="등록" v-if="editable"  icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'pid-master',
  props: {
    pidInfo: {
      type: Object,
      default(){
        return {
          diagramClassCd: '',
          title: '',
          typeFlag: true,
          pidNo: '도면번호',
          pidName: '도면명',
          attachName: '도면 첨부파일',
        }
      },
    },
  },
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'diagramKindName',
            field: 'diagramKindName',
            label: '도면분류',
            align: 'center',
            style: 'width:250px',
          },
          {
            name: 'diagramNo',
            field: 'diagramNo',
            label: '도면',
            align: 'center',
            style: 'width:200px',
          },
          {
            name: 'diagramTitle',
            field: 'diagramTitle',
            label: '도면명',
            align: 'left',
            type: "link",
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '관리부서',
            align: 'center',
            style: 'width:150px',
          },
          {
            name: 'processName',
            field: 'processName',
            label: '관련공정',
            align: 'center',
            style: 'width:200px',
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:150px',
            type: 'attach',
            taskClassCd: 'PSI_PID',
            keyText: 'psiDiagramId',
          },
          // {
          //   name: 'sopMocId',
          //   field: 'sopMocId',
          //   label: 'MOC 번호',
          //   align: 'center',
          //   style: 'width:140px',
          // },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        processCd: '',
        deptCd: '',
        diagramClassCd: '',
        diagramTitle: '',
        useFlag: 'Y',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      changeData: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
    
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      if (this.pidInfo.pidNo === undefined) {
        this.pidInfo.pidNo = '도면번호';
        this.pidInfo.pidName = '도면명';
        this.pidInfo.attachName = '도면 첨부파일';
      }
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.psi.diagram.list.url;
      if (!this.pidInfo.typeFlag) {
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:180px',
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            name: 'diagramNo',
            field: 'diagramNo',
            label: this.pidInfo.pidNo,
            align: 'center',
            style: 'width:200px',
          },
          {
            name: 'diagramTitle',
            field: 'diagramTitle',
            label: this.pidInfo.pidName,
            align: 'left',
            type: "link",
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '관리부서',
            align: 'center',
            style: 'width:150px',
          },
          {
            name: 'processName',
            field: 'processName',
            label: '관련공정',
            align: 'center',
            style: 'width:200px',
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:150px',
            type: 'attach',
            taskClassCd: 'PSI_PID',
            keyText: 'psiDiagramId',
          },
        ]
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.searchParam.diagramClassCd = this.pidInfo.diagramClassCd;
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () =>
      import(`${"./pidMasterDetail.vue"}`);
      this.popupOptions.title = this.pidInfo.title + ' 상세';
      this.popupOptions.param = {
        psiDiagramId: result ? result.psiDiagramId : null,
        diagramClassCd: this.pidInfo.diagramClassCd,
        title: this.pidInfo.title,
        pidNo: this.pidInfo.pidNo,
        pidName: this.pidInfo.pidName,
        attachName: this.pidInfo.attachName,
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      // this.$set(this.$refs['table'], 'changeData', !this.$refs['table'].changeData);
      this.changeData = !this.changeData
      this.getList();
    },
  }
};
</script>
